import { render, staticRenderFns } from "./BottomBanner.vue?vue&type=template&id=05f797e6&scoped=true"
import script from "./BottomBanner.vue?vue&type=script&lang=js"
export * from "./BottomBanner.vue?vue&type=script&lang=js"
import style0 from "./BottomBanner.vue?vue&type=style&index=0&id=05f797e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f797e6",
  null
  
)

export default component.exports